import { UseFormReset, UseFormReturn } from "react-hook-form";
import { CivilStatus } from "../../../enums/civil-status";
import { Gender } from "../../../enums/gender";
import {
  initialUserData,
  ModalType,
  UserInvitationType,
} from "../../user-invitation-modal/api/types";
import useUserInvStore, { IUserInvState } from "./store";
import { UserFormSchema, UserSchema } from "./schema";

export class Handlers {
  userInvStore: IUserInvState;
  constructor() {
    this.userInvStore = useUserInvStore.getState();
  }

  handleOpenModal = () => {
    this.userInvStore.setModal(true);
  };

  handleCloseModal = (
    reset: UseFormReset<UserSchema>,
    onClose?: () => void,
  ) => {
    this.userInvStore.setModal(false);
    this.userInvStore.setSelectedUser(undefined);
    this.userInvStore.setModalType(ModalType.QueryForm);
    this.userInvStore.resetAddingUser();

    reset(initialUserData);
    if (onClose) onClose();
  };

  handleBack = () => {
    if (this.userInvStore.modalType === ModalType.QueryResult) {
      this.userInvStore.setModalType(ModalType.QueryForm);
    } else if (this.userInvStore.modalType === ModalType.UserForm) {
      this.userInvStore.setModalType(ModalType.QueryResult);
    }
  };

  handleSelectActiveRecord = (
    createUserForm: UseFormReturn<UserFormSchema>,
    onSelectActiveRecord?: (user: UserFormSchema) => void,
  ) => {
    this.userInvStore.setClearingUserForm(true);
    setTimeout(() => {
      this.userInvStore.setClearingUserForm(false);

      if (this.userInvStore.selectedUser) {
        const user = this.userInvStore.selectedUser;
        // // Ensure enum fields are valid
        const formattedUser: UserFormSchema = {
          ...user,
          civilStatus: user.civilStatus,

          gender: user.gender,
          birthDate: user.birthDate ?? "",
          role: {
            id: "",
            name: "",
            displayName: "",
            role: "",
          },
        };
        onSelectActiveRecord?.(formattedUser);
      }
    }, 1000);
  };

  handleInviteNew = (
    queryType: UserInvitationType,
    onInviteNew?: (user: UserFormSchema) => void,
  ) => {
    var result: UserFormSchema = {
      id: "",
      email: "",
      lastName: "",
      firstName: "",
      civilStatus: 0,
      gender: 0,
      role: {
        id: "",
        name: "",
        displayName: "",
        role: "",
      },
      birthDate: "",
    };
    if (
      queryType === UserInvitationType.Email &&
      this.userInvStore.queryData.email
    ) {
      result.email = this.userInvStore.queryData.email;
    } else if (
      queryType === UserInvitationType.UserFullname &&
      this.userInvStore.queryData.firstName &&
      this.userInvStore.queryData.lastName
    ) {
      result.firstName = this.userInvStore.queryData.firstName;
      result.lastName = this.userInvStore.queryData.lastName;
    }
    onInviteNew?.(result);
  };
}
